import { useTranslator } from "@eo-locale/react";

import {
  ReactNode,
  Children,
  isValidElement,
  cloneElement,
  ReactElement
} from "react";

import { CloseIcon, Flex, Heading, IconButton } from "@/storybook-components";

function Sidebar({
  aboutContent,
  onClose
}: {
  aboutContent: ReactNode;
  onClose: () => void;
}) {
  const { translate } = useTranslator();

  return (
    <Flex
      px={4}
      pb={6}
      bg="gray.100"
      width="100%"
      maxWidth={{ lg: 480 }}
      height={{ lg: "100vh" }}
      position={{ md: "absolute", lg: "sticky" }}
      top={0}
      bottom={0}
      zIndex={1000}
      overflow="auto"
      flex={1}
      direction="column"
    >
      <Flex
        py={6}
        top={0}
        zIndex={2}
        align="center"
        position="sticky"
        background="gray.100"
        justify="space-between"
      >
        <Heading
          as="h2"
          fontSize="md"
          fontWeight="semibold"
          lineHeight="shorter"
        >
          {translate("common.about")}
        </Heading>
        <IconButton
          size="xs"
          icon={<CloseIcon />}
          variant="ghost"
          onClick={onClose}
          aria-label={translate("common.closePanel")}
          data-testid="ideas-sidebar-close"
        />
      </Flex>
      {Children.map(aboutContent, (child) => {
        if (isValidElement(child)) {
          return cloneElement(child as ReactElement<any>, {
            closeSideBar: onClose
          });
        }
        return child;
      })}
    </Flex>
  );
}

export default Sidebar;
